import { topSidePartOfWeb } from './parts/sideParts'

export const bomberOriginalWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  // 斜線上段
  ctx.moveTo(356, 118) // 右上
  ctx.quadraticCurveTo(284, 212, 257, 313) // 左下
  // 斜線下段
  ctx.moveTo(364, 185) // 右上
  ctx.quadraticCurveTo(315, 263, 286, 350) // 左下
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 斜線上周り
  ctx.moveTo(232, 264) // 左上
  ctx.quadraticCurveTo(261, 175, 352, 110) // 右上
  ctx.quadraticCurveTo(352, 115, 352, 115) // 右下
  ctx.quadraticCurveTo(280, 215, 258, 298) // 左下
  ctx.moveTo(257, 295) // 左下
  ctx.quadraticCurveTo(275, 212, 352, 112) // 右下
  // 斜線中周り_外
  ctx.moveTo(262, 303) // 左上
  ctx.quadraticCurveTo(297, 197, 354, 126) // 右上
  ctx.quadraticCurveTo(361, 185, 361, 185) // 右下
  ctx.quadraticCurveTo(309, 264, 285, 343) // 左下
  // 斜線中周り_内
  ctx.moveTo(265, 306) // 左上
  ctx.quadraticCurveTo(292, 216, 352, 135) // 右上
  ctx.quadraticCurveTo(358, 185, 358, 185) // 右下
  ctx.quadraticCurveTo(305, 260, 282, 343) // 左下
  // 斜線下周り_外
  ctx.moveTo(290, 348) // 左上
  ctx.quadraticCurveTo(315, 272, 361, 196) // 右上
  ctx.quadraticCurveTo(370, 246, 368, 252) // 右下
  // 斜線下周り_内
  ctx.moveTo(290, 351) // 左上
  ctx.quadraticCurveTo(320, 273, 361, 200) // 右上
  ctx.quadraticCurveTo(365, 246, 366, 255) // 右下

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  // 上段
  crossLaceOfBomberWeb(ctx, laceColor, -18, 40)
  crossLaceOfBomberWeb(ctx, laceColor, 0, 0)
  crossLaceOfBomberWeb(ctx, laceColor, 25, -45)
  crossLaceOfBomberWeb(ctx, laceColor, 50, -90)
  // 右側
  ctx.beginPath()
  ctx.moveTo(332, 133) // 左上
  ctx.quadraticCurveTo(340, 153, 340, 158) // 左下
  ctx.quadraticCurveTo(346, 154, 346, 148) // 右下
  ctx.quadraticCurveTo(345, 128, 338, 125) // 右上
  ctx.quadraticCurveTo(332, 125, 332, 133) // 左上
  ctx.fill()
  // // 断面ライン
  ctx.moveTo(332, 131) // 左上
  ctx.quadraticCurveTo(344, 143, 342, 158) // 左下
  ctx.stroke()
  ctx.closePath()

  // 下段
  crossLaceOfBomberWeb(ctx, laceColor, 30, 50)
  crossLaceOfBomberWeb(ctx, laceColor, 55, 0)
  crossLaceOfBomberWeb(ctx, laceColor, 75, -40)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
}

const crossLaceOfBomberWeb = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  // 左側
  ctx.beginPath()
  ctx.moveTo(259 + x, 265 + y) // 左上
  ctx.quadraticCurveTo(270 + x, 274 + y, 281 + x, 273 + y) // 左下
  ctx.quadraticCurveTo(285 + x, 267 + y, 282 + x, 266 + y) // 右下
  ctx.quadraticCurveTo(261 + x, 255 + y, 261 + x, 255 + y) // 右上
  ctx.quadraticCurveTo(256 + x, 258 + y, 259 + x, 265 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(261 + x, 255 + y) // 左上
  ctx.quadraticCurveTo(263 + x, 262 + y, 282 + x, 266 + y) // 右下
  ctx.stroke()
  ctx.closePath()

  // 右側
  ctx.beginPath()
  ctx.moveTo(266 + x, 247 + y) // 左上
  ctx.quadraticCurveTo(271 + x, 263 + y, 270 + x, 285 + y) // 左下
  ctx.quadraticCurveTo(273 + x, 285 + y, 276 + x, 278 + y) // 右下
  ctx.quadraticCurveTo(277 + x, 250 + y, 271 + x, 237 + y) // 右上
  ctx.quadraticCurveTo(266 + x, 238 + y, 266 + x, 247 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(266 + x, 247 + y) // 下
  ctx.quadraticCurveTo(274 + x, 263 + y, 270 + x, 285 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}
